'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const tslib_es6 = require('../tslib.es6-CZ43up4V.js');
const react = require('@emotion/react');
const designSystem = require('@zapier/design-system');
const reactAriaComponents = require('react-aria-components');

const styles = react.css(Object.assign(Object.assign({}, designSystem.Typography.SmallPrint1), { color: `var(--zds-status-error-stronger, ${designSystem.Colors.StatusErrorStrongest})`, "&.compact": Object.assign({}, designSystem.Typography.MinimalPrint1) }));
const ErrorMessage = (_a) => {
  var { children, isCompact } = _a, props = tslib_es6.__rest(_a, ["children", "isCompact"]);
  return react.jsx(reactAriaComponents.FieldError, Object.assign({}, props, {
    // Passing compact as a class name instead of a data attribute because FieldError does not spread data attributes. Only these props get passed: https://github.com/adobe/react-spectrum/blob/main/packages/%40react-spectrum/s2/src/NumberField.tsx#L400-L406
    className: isCompact ? "compact" : void 0,
    css: styles,
    "data-compact": isCompact,
    "data-zds": true
  }), children);
};

exports.ErrorMessage = ErrorMessage;
//# sourceMappingURL=ErrorMessage.cjs.js.map
